import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react"
import dynamic from "next/dynamic"
import * as PropTypes from "prop-types"
import styled from "styled-components"
import { mq } from "helpers/styled"
import { RentingContext } from "../RentingContext"

const DynamicFilter = dynamic(() => import("components/Filter"))
const DynamicModal = dynamic(() => import("components/FilterModal"))

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  transform: translateY(100%);
  transition: transform 0.5s;
  ${({ show }) => show && "transform: translateY(0%)"};

  @media ${mq("lg")} {
    display: none;
  }
`

const Wrapper = styled.div`
  display: none;
  width: 250px;
  height: fit-content;
  min-width: 250px;
  margin-right: 7px;
  padding: 15px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 10px;

  @media ${mq("lg")} {
    ${({ show }) => show && "display: block"};
  }

  @media ${mq("xl")} {
    margin-right: 20px;
  }
`

export const FilterContext = createContext({})

export default function Filter({ show, setShow, onUpdate, isDesktop }) {
  const { page } = useContext(RentingContext)
  const [delayedShow, setDelayedShow] = useState(false)
  const timeout = useRef(0)

  const hide = useCallback(() => {
    setShow(null)
  }, [setShow])

  useEffect(() => {
    if ((isDesktop && show === "mobile") || (!isDesktop && show === "desktop")) {
      setShow(null)
      setDelayedShow(null)
      clearTimeout(timeout.current)
    }
  }, [isDesktop, setShow, show])

  useEffect(() => {
    if (isDesktop) return

    if (timeout.current) clearTimeout(timeout.current)
    timeout.current = setTimeout(() => setDelayedShow(show), 500)
  }, [isDesktop, show])

  return (
    <>
      <ModalWrapper show={show === "mobile"}>
        {(show === "mobile" || delayedShow) && <DynamicModal handleClose={hide} page={page} onUpdate={onUpdate} />}
      </ModalWrapper>
      <Wrapper as="aside" show={show === "desktop"}>
        {show === "desktop" && <DynamicFilter handleClose={hide} page={page} onUpdate={onUpdate} />}
      </Wrapper>
    </>
  )
}

Filter.defaultProps = {
  show: null
}

Filter.propTypes = {
  show: PropTypes.string,
  setShow: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired
}
